import React, { useEffect } from 'react';
import './App.css';
import Header from './Header';
import Sidebar from './Sidebar';
import Mail from './Mail';
import EmailList from './EmailList'
import {
  Routes,
  Route,
} from "react-router-dom";
import SendMail from './SendMail';
import {useDispatch, useSelector} from 'react-redux'; 
import { selectsendmessageisopen } from './features/mailSlice';
import { Loginto, selectuser } from './features/userSlice';
import Login from './Login';
import { auth } from './firebase';


function App() {

  const sendmessageisopen = useSelector(selectsendmessageisopen);
  const user = useSelector(selectuser);
  const dispatch = useDispatch();
  useEffect(() => {
auth.onAuthStateChanged(user => {
  if(user){

      dispatch(Loginto({
        displayName : user.displayName,
        email : user.email,
        photoUrl : user.photoURL,
      }))


  }
})
  },[]);

  return (
     
    <div>
    {!user ? (
    <Login/>
  ):(
    <div className="app">
    <Header/>
    <div className='app_body'>
    <Sidebar/>
    <Routes>
    <Route path="/" element={<EmailList />} />
    <Route path="/Mail" element={<Mail />} /> 
    </Routes>
    </div>
    {sendmessageisopen && <SendMail/> }
    </div>

      )}
    
    </div>
  );
  
}


export default App;
